import { FlexBox, Text } from '@fable/components'
import { css } from '@fable/theme'
import { useGoalHabits } from '../../lib/ctx'
import { getMonthYAxisIncrement } from '../../lib/utils'
import { formatK } from '@fable/utils'
import { useStatsTheme } from 'app/webview/pages/stats_profile/theme/ctx'

export const MonthRadarYAxis = () => {
  const theme = useStatsTheme((s) => s.theme)
  const [maxValue] = useGoalHabits((s) => [s.monthMaxValue])

  const increment = getMonthYAxisIncrement(maxValue)
  const yAxisLength = Math.ceil(maxValue / increment)

  return (
    <FlexBox
      className={css`
        padding-top: 1px;
        padding-bottom: 23px;
        width: 100%;
        height: 51%;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        pointer-events: none;
      `}
      flexDirection="column"
      alignItems="center"
      justifyContent="space-between"
    >
      {Array.from({
        length: yAxisLength,
      }).map((_, i) => {
        const num = (i + 1) * increment

        const getText = () => {
          if (num < 10) return `0${num}`
          if (num > maxValue) return formatK(maxValue)
          return formatK(num)
        }

        return (
          <FlexBox
            key={num}
            className={css`
              flex: 1;
              padding-left: 10px;
              padding-bottom: 1px;
            `}
            alignItems="flex-end"
          >
            <Text
              className={css`
                font-size: 5px;
                line-height: 5px;
              `}
              type="body"
              weight="500"
              align="center"
              color={theme.colors.section.textSecondary}
            >
              {getText()}
            </Text>
          </FlexBox>
        )
      })}
    </FlexBox>
  )
}
